// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FareEstimateResultQueryParamsV1$PorterinFeature from "../../containers/fare-estimate-v1/domain/types/FareEstimateResultQueryParamsV1.mjs";

var defaultValue_fare_result = {
  TAG: /* Loading */0,
  _0: undefined
};

function defaultValue_set_fare_result(param) {
  
}

var defaultValue_is_valid_params = {
  TAG: /* Loading */0,
  _0: undefined
};

function defaultValue_set_is_retry(param) {
  
}

function defaultValue_set_selected_vehicle(param) {
  
}

function defaultValue_set_selected_vehicle_fare(param) {
  
}

function defaultValue_set_does_customer_exist(param) {
  
}

var defaultValue = {
  fare_result: defaultValue_fare_result,
  set_fare_result: defaultValue_set_fare_result,
  query_params: FareEstimateResultQueryParamsV1$PorterinFeature.getDefault,
  is_valid_params: defaultValue_is_valid_params,
  is_retry: false,
  set_is_retry: defaultValue_set_is_retry,
  selected_vehicle: 0,
  set_selected_vehicle: defaultValue_set_selected_vehicle,
  selected_vehicle_fare: "0",
  set_selected_vehicle_fare: defaultValue_set_selected_vehicle_fare,
  does_customer_exist: undefined,
  set_does_customer_exist: defaultValue_set_does_customer_exist
};

var context = React.createContext(defaultValue);

function useFareEstimateContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useFareEstimateContext ,
}
/* context Not a pure module */
